import React from "react";
import { Footer, Navbar } from "../components";
import { Route, Routes } from "react-router-dom";
import { Basket, Catalog, DetailsV1, DetailsV2, Home, Search } from "./pages";

const User = () => {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/basket" element={<Basket />} />
        <Route path="/catalog/:type" element={<Catalog />} />
        <Route path="/details/v1/:detail/:id" element={<DetailsV1 />} />
        <Route path="/details/v2/:id" element={<DetailsV2 />} />
        <Route path="/search" element={<Search />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default User;
